import RsaDynamicAreaBody from "../index.js";

const routes = [
    {
        name: "RsaDynamicArea",
        path: "/rsaarea",
        component: RsaDynamicAreaBody.RsaDynamicBodyAreaPage,
        meta: { title: " Area" },
    },
];

export default routes;
